// utmTracking.js
//
// Замінює стару логіку `plugins/salesdrive-new/js/salesdrive.js` (кукі
// "prodex24*"), яка ніколи не працювала на headless Gatsby-фронтенді — той
// скрипт розрахований на класичний (не headless) чекаут WordPress і на
// поточному сайті просто ніколи не завантажується. Оформлення замовлення
// йде через серверну функцію CreateOrder (Netlify), яка звертається до
// WooCommerce REST API напряму з бекенду — cookie браузера клієнта туди
// в принципі не долітають, тож дані з UTM/referrer треба явно передавати
// через meta_data замовлення (той самий підхід, що вже є для ga_client_id/
// ga_session_id в Checkout.js), а не через $_COOKIE на боці PHP.
//
// Бекенд (SalesdriveOrderSync.php/salesdriveClass.php) вже вміє читати
// ці дані з order meta як fallback, коли кукі немає — просто досі ніхто
// не наповнював цю мету реальними значеннями.

const UTM_STORAGE_KEY = "molfar_utm_data";
// Те саме вікно атрибуції, що й було в старому cookie-скрипті
// (prodex24*, expires: 365 днів) — щоб дуже давній перший візит не
// продовжував "красти" атрибуцію в замовлення, оформленого набагато пізніше.
const UTM_TTL_MS = 365 * 24 * 60 * 60 * 1000;

const ORGANIC_REFERRER_HOSTS = /^(((google|search\.yahoo|yandex|bing)(\.[^.]+)+)|(rambler\.ru)|(ukr\.net)|(mail\.ru))$/i;

function parseQueryParams(search) {
    const params = new URLSearchParams(search || "");
    return {
        utm_source: params.get("utm_source") || "",
        utm_medium: params.get("utm_medium") || "",
        utm_campaign: params.get("utm_campaign") || "",
        utm_content: params.get("utm_content") || "",
        utm_term: params.get("utm_term") || "",
        gclid: params.get("gclid") || "",
        yclid: params.get("yclid") || "",
    };
}

// Викликати ОДИН РАЗ на реальне (не SPA-перехідне) завантаження сторінки —
// напр. з gatsby-browser.tsx onClientEntry. document.referrer не оновлюється
// під час client-side навігації Gatsby, тож повторний виклик на кожен
// внутрішній перехід нічого нового не додасть, лише зайва робота.
export function captureUtmData() {
    if (typeof window === "undefined") {
        return;
    }

    const { utm_source, utm_medium, utm_campaign, utm_content, utm_term, gclid, yclid } = parseQueryParams(window.location.search);
    const hasUtm = utm_source || utm_medium || utm_campaign || utm_content || utm_term || gclid || yclid;

    const referrer = document.referrer || "";
    let referrerHost = "";
    try {
        referrerHost = referrer ? new URL(referrer).hostname : "";
    } catch (e) {
        referrerHost = "";
    }
    const isExternalReferrer = Boolean(referrer && referrerHost && referrerHost !== window.location.hostname);

    let data = null;

    if (hasUtm) {
        data = {
            source: utm_source || (gclid ? "google" : ""),
            medium: utm_medium || (gclid || yclid ? "cpc" : ""),
            campaign: utm_campaign,
            content: utm_content,
            term: utm_term,
            source_full: isExternalReferrer ? referrer : "",
        };
    } else if (isExternalReferrer) {
        const domain = referrerHost.replace(/^www\./i, "");
        data = {
            source: domain,
            medium: ORGANIC_REFERRER_HOSTS.test(domain) ? "organic" : "referral",
            campaign: "",
            content: "",
            term: "",
            source_full: referrer,
        };
    }

    if (!data) {
        return;
    }

    try {
        window.localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify({ ...data, savedAt: Date.now() }));
    } catch (e) {
        // localStorage може бути недоступний (приватний режим тощо) — не критично,
        // просто це замовлення піде без utm-атрибуції.
    }
}

// Викликати при побудові meta_data запиту CreateOrder (Checkout.js) — ключі
// збігаються з тим, що читає бекенд (prodex24source/prodex24medium/...).
export function getUtmMetaData() {
    if (typeof window === "undefined") {
        return {};
    }
    try {
        const raw = window.localStorage.getItem(UTM_STORAGE_KEY);
        if (!raw) {
            return {};
        }
        const parsed = JSON.parse(raw);
        if (!parsed.savedAt || Date.now() - parsed.savedAt > UTM_TTL_MS) {
            window.localStorage.removeItem(UTM_STORAGE_KEY);
            return {};
        }
        return {
            prodex24source: parsed.source || "",
            prodex24medium: parsed.medium || "",
            prodex24campaign: parsed.campaign || "",
            prodex24content: parsed.content || "",
            prodex24term: parsed.term || "",
            prodex24source_full: parsed.source_full || "",
        };
    } catch (e) {
        return {};
    }
}
